export type DriverOutcome =
  | 'active_by_invitation'
  | 'existing_active_employment'
  | 'pending_no_invitation'
  | 'pending_no_license'
  | 'company_contact_submitted'
  | 'failed';

export type DriverPayer = 'self' | 'company';

export type DriverOutcomeCopy = {
  title: string;
  message: string;
};

const CONTEXTUAL_COPY: Record<DriverOutcome, DriverOutcomeCopy> = {
  active_by_invitation: {
    title: 'outcomeActiveTitle',
    message: 'outcomeActiveMessage',
  },
  existing_active_employment: {
    title: 'outcomeActiveTitle',
    message: 'outcomeActiveMessage',
  },
  pending_no_invitation: {
    title: 'outcomePendingInviteTitle',
    message: 'outcomePendingInviteMessage',
  },
  pending_no_license: {
    title: 'outcomePendingLicenseTitle',
    message: 'outcomePendingLicenseMessage',
  },
  company_contact_submitted: {
    title: 'outcomeContactTitle',
    message: 'outcomeContactMessage',
  },
  failed: {
    title: 'outcomeFailedTitle',
    message: 'outcomeFailedMessage',
  },
};

/**
 * Driver-facing copy is intentionally less specific than owner/company copy.
 * In particular, DRV-CO must not learn whether a pending state came from a
 * missing invitation, missing licence, or an unknown company. Self-pay keeps
 * the contextual contact message because that surface is explicitly about the
 * driver's own company declaration and lead.
 */
export function getDriverOutcomeCopy(
  outcome: DriverOutcome | string,
  payer: DriverPayer | string,
): DriverOutcomeCopy {
  if (outcome === 'company_contact_submitted' && payer === 'company') {
    return CONTEXTUAL_COPY.pending_no_invitation;
  }
  return CONTEXTUAL_COPY[outcome as DriverOutcome] ?? CONTEXTUAL_COPY.failed;
}
